module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/发展空间.3486ab66.png";